var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"tile":_vm.tile}},[_c('v-img',_vm._b({attrs:{"src":_vm.thumbSrc,"alt":_vm.alt}},'v-img',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }